    /**
     * Partners stack effect (per-card pinning, scale, subtle rotation)
     * Matches the provided CodePen behavior
     */
    function initPartnersStack() {
        const cardsWrappers = gsap.utils.toArray(".slide-up-content-cards .card-wrapper");
        const cards = gsap.utils.toArray(".content-card");

        cardsWrappers.forEach((wrapper, i) => {
          const card = cards[i];
          const isLast = i === cards.length - 1;
          let scale = 1;
          if (!isLast) {
            scale = 0.7 + 0.025 * i;
          }

          const tweenProps = {
            scale: scale,
            transformOrigin: "center center",
            ease: "none",
            scrollTrigger: {
              trigger: wrapper,
              start: "center center",
              end: "+=300",
              endTrigger: ".cards-wrapper",
              scrub: true,
              pin: wrapper,
              pinSpacing: false,
              id: i + 1
            }
          };

          // Non-last cards fade out; last card stays visible
          if (!isLast) {
            tweenProps.opacity = 0;
          }

          gsap.to(card, tweenProps);
        });
    }
